import React, { useEffect } from 'react';
import { Briefcase, Leaf, Users, BarChart3, ShieldCheck, Calendar } from 'lucide-react';
import UseCaseTemplate from '../../components/UseCaseTemplate';

const HERO_IMG = '/assets/images/corporation.jpg';

const CorporationsCompanies = () => {
  useEffect(() => {
    document.title = 'Corporations and Companies | Where It’s Used | Magomeal';
  }, []);

  const benefits = [
    {
      icon: <Leaf size={28} />,
      title: 'Achieve ESG Goals',
      description: 'Replace plastic cups, stirrers and cutlery in offices and events to measurably reduce single-use waste.',
    },
    {
      icon: <Briefcase size={28} />,
      title: 'Office Coffee & Pantries',
      description: 'Bring an everyday wow-moment to coffee corners, breakrooms and team kitchens, zero plastic, zero washing up.',
    },
    {
      icon: <Calendar size={28} />,
      title: 'Conferences & Events',
      description: 'Deliver branded sustainability statements at townhalls, summits, off-sites and product launches.',
    },
    {
      icon: <Users size={28} />,
      title: 'Employee Engagement',
      description: 'Give teams a tangible, memorable signal that your company is serious about sustainability.',
    },
    {
      icon: <BarChart3 size={28} />,
      title: 'Reportable Impact',
      description: 'Quantify reductions in plastic and CO\u2082 to support sustainability reporting and investor communications.',
    },
    {
      icon: <ShieldCheck size={28} />,
      title: 'Compliance Ready',
      description: 'Aligned with EU single-use plastics directives and food-grade compliance, audit-friendly documentation provided.',
    },
  ];

  return (
    <UseCaseTemplate
      eyebrow="Where It’s Used"
      title="Corporations and Companies"
      subtitle="Live your sustainability values, from coffee corners to global events."
      heroImage={HERO_IMG}
      imageAlt="Corporate professional with a Cupffee edible cup at the office"
      intro="Sustainability has moved from nice-to-have to non-negotiable. Magomeal’s edible cups and cutlery help corporations replace single-use plastic across daily operations and events with a solution that’s functional, premium and verifiable. From everyday office coffee to flagship conferences, you give teams and guests a small but powerful daily reminder that your company walks the talk on environmental responsibility."
      benefitsTitle="Sustainability that scales with your business"
      benefitsSubtitle="From single offices to multi-site organizations."
      benefits={benefits}
      ctaTitle="Roll out edible serveware company-wide"
      ctaText="Talk to our team about pilots, multi-site rollouts and integration with your facilities partners."
      primaryCta={{ label: 'Schedule a Call', to: '/contact' }}
      secondaryCta={{ label: 'View Products', to: '/shop' }}
    />
  );
};

export default CorporationsCompanies;
